var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-timeline',_vm._l((_vm.list),function(item,index){return _c('el-timeline-item',{key:index,attrs:{"icon":item.icon,"type":item.type,"color":item.color,"size":item.size,"timestamp":item.timestamp}},[_vm._v("\n      "+_vm._s(item.content)+"\n      ")])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fb37da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserLogsTimeline.vue
// module id = null
// module chunks = 